// Colocated Driver.js tour for the User Transaction Limits modal,
// opened from a user's row on Partner Details and targeted at admins
// and team reviewers who can manage this user's limits. This is a
// small tour, deliberately: it only fires while the modal is open and
// it has no FAQ outro (the FAQ entry point lives outside the modal).
// Three steps at most, and the revoke step is skipped when the user
// has no limits to revoke, so the tour always lands on real targets.

export const ADMIN_LIMITS_PANEL_TOUR_ID = 'admin-limits-panel-v1';

// Match the "visible one out of duplicated markup" trick used elsewhere in
// the app: the revoke button is rendered once per limit row, and any of
// them can serve as the tour anchor.
const firstVisibleRevokeButton = () => {
    const candidates = document.querySelectorAll('[data-tour="user-limits-revoke-button"]');
    for (const candidate of candidates) {
        if (candidate.offsetParent !== null) return candidate;
    }
    return null;
};

const revokeStep = {
    element: firstVisibleRevokeButton,
    title: 'Change your mind about a limit?',
    description: 'The red X on a limit is your escape hatch. On a temporary limit it ends the extension early and puts this person back on their original ceiling. On a permanent limit it removes the ceiling entirely. Either way we email the person and every super admin so the change is on record.',
    side: 'left',
    align: 'start',
};

export const buildAdminLimitsPanelTourSteps = ({ includeRevokeStep }) => {
    const steps = [
        {
            element: '[data-tour="user-limits-existing-section"]',
            title: 'What they can spend today',
            description: 'Existing Limits shows this person\'s current ceilings by period (daily, weekly, monthly, per-transaction). Green cards are permanent limits you set. Red cards are temporary extensions approved through a request; they end on their own once the expiry hits.',
            side: 'bottom',
            align: 'center',
        },
    ];

    if (includeRevokeStep) {
        steps.push(revokeStep);
    }

    steps.push({
        element: '[data-tour="user-limits-add-form"]',
        title: 'Set or change a limit',
        description: 'Pick a limit type, type an amount up to KES 150,000, and tap Add. Adding a limit of a type this person already has replaces the old one automatically. A per-transaction limit sits alongside period-based limits without overriding them.',
        side: 'top',
        align: 'center',
    });

    return steps;
};
